import { InsCount } from 'constants/enums/insCount.enum';

/**
 * @description 保險人數代碼對應投保對象人數用
 */
const InsuredPersonMatch: Readonly<Record<InsCount, number>> = {
  [InsCount.One]: 1,
  [InsCount.MORE]: 10
};

export default InsuredPersonMatch;
